'use strict';
import MSALInstance from '@/auth/auth';
import store from '@/store/index';
import rolePermissionMap from '../rolesMapping.json';
import userApi from '../api/modules/users';

export const handleUnauthRoute = (to, from, next) => {
    MSALInstance.checkAuth()
        .then(() => next('/'))
        .catch(() => next());
};

export const handleAuthRoute = (to, from, next) => {
    MSALInstance.checkAuth()
        .then(() => next())
        .catch(() => next({ path: '/login' }));
};

export const handleRouteAccess = (route) => {
    return new Promise((resolve, reject) => {
        let isPermitted = false;
        const roles = store.state.users.roles;
        roles?.forEach((role) => {
            const roleObject = rolePermissionMap[role];

            if (roleObject) {
                if (roleObject.routes.includes(route)) {
                    isPermitted = true;
                }
            }
        });
        if (isPermitted) {
            resolve();
        } else {
            reject();
        }
    });
};

export const routeAccessMixin = {
    mounted() {
        handleRouteAccess(this.$route.name).catch(() => {
            this.$router.replace({
                name: 'unauthorized',
            });
        });
    },
};

export const personaRouterMiddleware = (to, from, next) => {
    userApi
        .getCurrentUserAPI()
        .then((res) => {
            const userId = res.data.userId;
            userApi
                .getUserRolesAPI(userId)
                .then((res) => {
                    if (res.data.includes('role_payment_processing')) {
                        next();
                    } else if (res.data.includes('role_admin')) {
                        next({ name: 'user-management' });
                    } else if (res.data.includes('role_audit')) {
                        next({ name: 'audit-logs' });
                    } else if (res.data.length == 1 && res.data.includes('role_user')) {
                        next('user-settings');
                    } else {
                        next({ name: 'request-list' });
                    }
                })
                .catch(() => next({ name: 'user-settings' }));
        })
        .catch(() => next({ name: 'user-settings' }));
};
